import React, { useState, useEffect, useContext } from 'react';
import { UserContext } from 'utils/getContext'
import { List, Card, Collapse } from 'antd-mobile'
import { getEmpQuery } from 'api/api';
import { userInfoHide, idCardHide } from "utils/ruleType";
import 'static/css/empQuery.css'

const { Panel } = Collapse;

/**个人信息*/
export function EmpQuery(props) {
  const myContext = useContext(UserContext)
  const { userInfo } = myContext
  // 个人信息
  const [empQuery, setEmpQuery] = useState([]);
  // 表格数据
  const [jobIntent, setJobIntent] = useState([]);

  useEffect(() => {
    if (userInfo && userInfo.idNum) {
      const { idNum } = userInfo;
      getEmpQuery(idNum).then((res) => {
        const { data: resData } = res;
        const { data } = resData;

        if (data) {
          let obj = [];
          // 重写数据，确保每个字段都有值且格式正确,将其转换为Descriptions所需的数据格式
          obj = [
            { label: '姓名', value: data.name ? idCardHide(data.name, 1, data.name.length - 1) : '' },
            { label: '民族', value: data.nation || '' },
            { label: '身份证号码', value: data.idNum ? userInfoHide(data) : '' },
            { label: '证件类别', value: data.cerCat || '' },
            { label: '出生日期', value: data.birth || '' },
            { label: '性别', value: data.sex || '' },
            { label: '手机号码', value: data.phoNum || '' },
            { label: '政治面貌', value: data.politics || '' },
            { label: '人员类别', value: data.peride || '' },
            { label: '户口性质', value: data.regiPerm || '' },
            { label: '就失业登记证号', value: data.empNum || '' },
            // { label: '就失业登记证号', value: data.empRegi || '' },
            { label: '发证日期', value: data.authDate || '' },
            { label: '发证单位', value: data.authUnit || '' },
            { label: '就业状态', value: data.empState || '' },
            { label: '是否困难就业', value: data.isDifficult || '' },
            { label: '是否灵活就业', value: data.isFlexible || '' },
            { label: '是否申领就业创业电子证', value: data.certApply || '' },
          ];
          // 重写数据，确保每个字段都有值且格式正确,将其转换为Table所需的数据格式
          const arr = [];
          const jobIntentData = data.jobIntent;
          jobIntentData.forEach((item) => {
            arr.push({
              contractEndDate: item.contractEndDate || '',
              contractStartDate: item.contractStartDate || '',
              empDay: item.empDay || '',
              getLoseWorkNum: item.getLoseWorkNum || '',
              getLoseWorkUnit: item.getLoseWorkUnit || '',
              name: item.name || '',
              peopleType: item.peopleType || '',
              reason: item.reason || '',
              regiDate: item.regiDate || '',
              regiType: item.regiType || '',
              unempDay: item.unempDay || '',
            });
          });
          setEmpQuery(obj);
          setJobIntent(arr);
        }
      });
    }
  }, [userInfo]);
  return (
    <div id="empQuery">
      <Collapse defaultActiveKey={['2']} className="collapse">
        <Panel title="个人基本信息" key="1">
          {
            empQuery.length > 0 &&
            (<List className='list'>
              {empQuery.map((item) => (
                <List.Item key={item.label} extra={item.value} className='list-item'>
                  {item.label}
                </List.Item>
              ))}
            </List>)
          }
        </Panel>
        {/* <h3>就失业登记记录</h3> */}
        <Panel title="就失业登记记录" key="2">
          {jobIntent.length > 0 && jobIntent.map((item, index) => (
            <Card key={index} className='card'>
              <List className='card-list'>
                <List.Item extra={item.name}>姓名</List.Item>
                <List.Item extra={item.regiType}>登记类型</List.Item>
                <List.Item extra={item.regiDate}>登记日期</List.Item>
                <List.Item extra={item.getLoseWorkUnit}>就业单位/自主就业类型</List.Item>
                <List.Item extra={item.reason}>失业/注销失业原因</List.Item>
                <List.Item extra={item.unempDay}>失业/退出失业日期</List.Item>
                <List.Item extra={item.empDay}>实现/终止就业日期</List.Item>
              </List>
            </Card>
          ))}
        </Panel>
      </Collapse>
    </div>
  )
}